letterAdjust.y = 2;
letterAdjust.x = 2;
letterAdjust.scale = .7;

var font_size = 24,
    panel_Hor_Adjustment = 4,
    font_Top_Adjustment = 1,
    tracking = .5,
    middleSplitAdjustment = -0.5,
    middleSpreadAdjustment = {
        left: 1,
        right: 1
    },
    small_Caps_Adjustment = {
        vertical: -268.25,
        horizontal: 0,
        scale_width: .225,
        scale_height: .225,
    },
    number_Adjustments = {
        top: -4,
        left: -10,
        width: 86,
        height: 74,
        middle_Space: 7,
        oneOffset: 6
    },
    colors = {
        characters: {
            athletic: [
                '#FFFFFF', // white
            ],
            academic: [
                '#0076c0', // lightblue
            ]
        },
        numbers: {
            athletic: [
                '#FFFFFF', // white
                "#005da6", // blue
                "#babcbe", // grey
            ],
            academic: [
                '#0076c0', // lightblue
                '#FFFFFF', // white
                "#babcbe", // grey
            ]
        }
    },
    outlines = {
        characters: {
            width: 1.7
        },
        numbers: {
            width: 3
        }
    },
    special_Character_Adjustments = {
        period: {
            vertical: 0.5, // this moves it up from the bottom
            horizontal: 1,
            scale_width: 15.5,
            scale_height: 15.5,
        },
        hyphen: {
            vertical: -6,
            horizontal: -5.5,
            scale_width: 0,
            scale_height: -3,
        },
        apostrophe: {
            vertical: 0.25, // this is backwards
            horizontal: -1,
            scale_width: 0,
            scale_height: 0,
        }
    };
